import { AnimatePresence, motion } from "framer-motion";
import { Check } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function SuccessModal() {
  const { success, setSuccess } = useApp();
  const close = () => setSuccess(null);
  const r = success?.receipt;
  return (
    <AnimatePresence>
      {success && (
        <motion.div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-[#0B0E14] p-4 overflow-y-auto no-scrollbar"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.div data-testid="success-modal" className="w-full max-w-md rounded-3xl p-7 sm:p-8 text-center relative overflow-hidden text-white"
            style={{ background: "linear-gradient(160deg,#6d28d9,#8b5cf6 45%,#4c1d95)", border: "1px solid #7c5ce0" }}
            initial={{ scale: 0.95, y: 30 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 30 }} transition={{ type: "spring", stiffness: 300, damping: 26 }}>
            <motion.div initial={{ scale: 0.3, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 260, damping: 14 }}
              className="w-24 h-24 rounded-full mx-auto mb-5 flex items-center justify-center" style={{ background: "rgba(255,255,255,0.14)", border: "3px solid #ffffff" }}>
              <Check size={52} strokeWidth={2.5} className="text-white" />
            </motion.div>
            <h2 className="font-display text-3xl font-black text-white" data-testid="success-title">{success.title}</h2>
            <p className="mt-2 text-white font-bold" data-testid="success-message">{success.message}</p>
            {success.sub && <p className="mt-1 text-sm text-white" data-testid="success-sub">{success.sub}</p>}

            {r && (
              <div className="mt-5 rounded-2xl p-4 text-left" style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }} data-testid="success-receipt">
                {r.map(([k, v]) => (
                  <div key={k} className="flex justify-between items-center gap-3 py-2 text-sm border-b border-white/10 last:border-0" data-testid={`receipt-row-${k.toLowerCase().replace(/\s+/g, "-")}`}>
                    <span className="text-white font-semibold uppercase text-[11px] tracking-wide">{k}</span>
                    <span className="font-bold text-right text-white">{v}</span>
                  </div>
                ))}
              </div>
            )}
            {success.ack && <p className="mt-4 text-[11px] leading-relaxed text-white text-left" data-testid="success-ack"><b>Acknowledgment:</b> {success.ack}</p>}

            <button data-testid="success-ok-btn" onClick={close} className="mt-6 w-full rounded-xl bg-white text-[#4c1d95] py-4 font-display text-lg font-black hover:bg-white/90 active:scale-[0.98] transition-[background-color,transform]">
              {success.okLabel || "DONE"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
